import React from "react";
import { styled } from "../stitches.config";
import { bodyLarge } from "./commonStyles/Fonts";
import Link from "../components/Link";
import { withThemeContext } from "./components/StitchesThemeProvider";

interface TagsProps {
  tags: Array<{
    name: string;
    url: string;
  }>;
  isDarkMode?: boolean;
  isSemi?: boolean;
}

const Tags: React.FC<TagsProps> = ({
  tags,
  isDarkMode,
  isSemi,
  ...props
}) => {
  return (

    <div className="container">
      <StyledTags className={isSemi ? "tags-semi" : ""} variant={isDarkMode ? "dark" : undefined}>
        {tags.length ?
          <>
            <p className={bodyLarge()}>Więcej: </p>
            {tags.map((tags) =>
              <Link to={tags.url}>
                <span className={bodyLarge()}>{tags.name}</span>
              </Link>
            )}
          </> :
          null
        }

      </StyledTags>
    </div>
  );
};

const StyledTags = styled("div", {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  maxWidth: "840px",
  "& a": {
    color: "$articleLinkColor",
    textDecoration: "none",
    margin: "0 12px 6px 0",
    "@bp4": {
      margin: "0 12px 0 0",
    },
    "span": {
      color: "$articleLinkColor",
      textDecoration: "$colors$articleLinkDecoration",
    }
  },
  "& p": {
    margin: "0 12px 0 0",
    width: "100%",
    "@bp4": {
      width: "auto",
    },
  },
  variants: {
    variant: {
      dark: {
        color: "$grayscale100",
      },
    },
  },
});

export default withThemeContext(Tags);
